import { motion } from 'motion/react';

const SliderMotion = ({
  children,
  keyProp,
  isBackward = false,
  className = '',
  disabled = false,
  duration = 0.15,
  stiffness = 300,
  damping = 30,
  opacity = 0,
  delay = 0,
  xAxis = 100,
  transition = {},
  turnOffOpacityTransition = false,
}) => {
  return (
    <motion.div
      key={keyProp}
      initial={disabled ? false : { opacity, x: isBackward ? -xAxis : xAxis }}
      animate={disabled ? false : { opacity: 1, x: 0 }}
      exit={disabled ? false : { opacity: 0 }}
      className={className}
      transition={{
        duration,
        x: { type: 'spring', stiffness, damping, delay },
        opacity: turnOffOpacityTransition ? false : { duration, delay },
        ...transition,
      }}>
      {children}
    </motion.div>
  );
};

export default SliderMotion;
